import t, { useEffect as o } from "react";
import { useTranslation as v } from "react-i18next";
import { useCountDown as k } from "../../../../../features/dom/hooks/useCountDown.js";
import { KioskButton as l } from "../../components/KioskButton/KioskButton.js";
import { KioskTitle as p } from "../../components/KioskTitle/KioskTitle.js";
import { useKioskLanding as d } from "../../context.js";
import a from "./inactive.module.scss.js";
function x() {
  const {
    configuration: i,
    lang: r,
    restart: s,
    back: m
  } = d(), [c] = k((i == null ? void 0 : i.inactive.settings.reloadTime) ?? 10, !0), { t: n } = v(), e = i == null ? void 0 : i.inactive.text[r];
  return o(() => {
    c === 0 && s();
  }, [c]), /* @__PURE__ */ t.createElement("div", { "data-testid": "inactive", className: a.inactive }, /* @__PURE__ */ t.createElement("div", { className: a.titleContainer }, /* @__PURE__ */ t.createElement(
    p,
    {
      text: (e == null ? void 0 : e.inactive_title) || n("kioskLanding.inactive.title")
    }
  )), /* @__PURE__ */ t.createElement("div", { className: a.prelude }, (e == null ? void 0 : e.inactive_cancel_order_will_cancel) || n("kioskLanding.inactive.prelude")), /* @__PURE__ */ t.createElement("div", { className: a.prelude }, c), /* @__PURE__ */ t.createElement("div", { className: a.buttons }, /* @__PURE__ */ t.createElement(l, { type: "secondary", onClick: () => s() }, (e == null ? void 0 : e.inactive_cancel_order) || n("kioskLanding.inactive.cancel")), /* @__PURE__ */ t.createElement(l, { type: "primary", onClick: () => m() }, (e == null ? void 0 : e.inactive_continue) || n("kioskLanding.inactive.continue"))));
}
export {
  x as Inactive
};
//# sourceMappingURL=Inactive.js.map
